import Swiper from 'swiper/dist/js/swiper';

export default () => {

  const popup = document.getElementById('building-gallery-popup');
  const closeBtn = document.getElementById('building-gallery-close-btn');
  const openBtn = document.getElementById('building-gallery-open-btn');
  if (!popup || !closeBtn || !openBtn) return;
  const OPENED = 'opened';
  let sliderInited = false;

  const initSlider = () => {
    sliderInited = true;
    const slider = new Swiper('#building-gallery-slider', {
      preloadImages: false,
      autoHeight: true,
      lazy: {
        loadPrevNext: true,
      },
      navigation: {
        nextEl: '#building-gallery-slider-next',
        prevEl: '#building-gallery-slider-prev',
      },
      pagination: {
        el: '#building-gallery-slider-progress',
        type: 'custom',
        renderCustom: function(swiper, current, total) {
          return `<strong>${current}</strong> / ${total}`;
        },
      },
      on: {
        lazyImageReady: function() {
          this.updateAutoHeight();
        },
      },
    });
  };

  const openPopup = () => {
    if (!sliderInited) initSlider();
    popup.classList.add(OPENED);
  };

  const closePopup = () => popup.classList.remove(OPENED);

  openBtn.addEventListener('click', openPopup);
  closeBtn.addEventListener('click', closePopup);
}
